import styled, { css } from 'styled-components'

import { BRAND } from 'constants/appConstants'
import { theme } from 'utils/theme'

export const InputContainer = styled.div`
  height: ${({ height }) => height ?? 'auto'};
  flex: 0 0 auto;
`

export const FormGroup = styled.div`
  position: relative;
  height: 100%;
  direction: rtl;
  input {
    background: transparent;
    color: ${theme.colors.white};
    border: none;
    box-shadow: inset 0 0 0 2px ${theme.colors.white};
    font-family: AzoSans;
    font-weight: 600;
    font-size: 30px;
    border-radius: 50px;
    padding: 0 100px 0 50px;
    height: 100%;
    -webkit-appearance: none;
    position: relative;
    transition: all 0.3s ease-out;
    text-align: left;
    width: calc(100% - 150px);
    direction: ltr;
    &:focus {
      outline: none;
      width: 100%;
    }

    ${({ theme: { brand } }) =>
      brand === BRAND.GCAD &&
      css`
        &::placeholder {
          color: ${theme.colors.white};
          opacity: 0.85;
        }
      `}
  }

  .icon-container {
    ${({ iconLeft }) => (!iconLeft ? 'margin: auto 0 auto 20px;' : 'margin: auto 20px auto 0;')}
    position: absolute;
    top: 0;
    right: 50px;
    bottom: 0;
  }
`
